export const localHeroContainer = {
  position: 'relative'
}

export const localHeroContainerHalfAndHalf = {
  position: 'relative',
  margin: 'auto',
  maxWidth: '1200px'
}

export const subTitle = {
  margin: '16px 0 0'
}

export const locations = {
  display: 'inline-block',
  padding: 0,
  float: 'left',
  width: '100%',

  li: {
    width: ['50%', '33%'],
    margin: ['0 0', 0],
    display: 'inline-block',
    listStyle: 'none',
    padding: 0,
    float: 'left'
  },

  a: {
    display: 'block',
    padding: '0.5em 0'
  }
}

export const locationList = {
  mx: 'auto',
  boxSizing: 'border-box',
  px: 16,
  maxWidth: ['100%', 800, 1000],
  position: 'relative',
  '@media screen and (min-width: 1200px)': {
    maxWidth: 1200
  }
}

export const titleContainer = {
  boxSizing: 'border-box',
  maxWidth: 'calc( 1200px - 2em )',
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 'auto',
  marginRight: 'auto'
}

export const formRow = {
  display: 'flex',
  flexWrap: 'wrap'
}

const col = {
  boxSizing: 'border-box',
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: 'auto'
}
export const formCol = {
  ...col,
  marginBottom: '1.5em',
  width: '100%'
}

export const heroContent = {
  my: 'sm'
}

export const heroForm = {
  marginBottom: ['md', 'xl']
}

export const formContainerCol = {
  ...col,
  width: ['100%', 'calc(66.6666% - 1em)', 'calc(41.6666% - 1em)'],
  minHeight: [344, 379]
}
